import api from "./api";

export function fnCreateQuickPublish(data) {
    const response = api.post("/version/quick-publish", data, { headers: { 'Content-Type': 'multipart/form-data;' } })
    return response
}
